import * as React from 'react';
import gs1 from '../../../../../assets/images/static_pages/getting_started_1.svg';
import gs2 from '../../../../../assets/images/static_pages/getting_started_2.svg';
import gs3 from '../../../../../assets/images/static_pages/getting_started_3.svg';
import { ViewMessageRates } from './ViewMessageRates';

export const GettingStarted = () => {
  const datas = [
    {
      id: 1,
      title: '1. Select a plan',
      body: 'Select the plan that fits your business needs. Each plan recurs either monthly or annually, offering you a set of features tailored to your needs.',
      image: gs3,
    },
    {
      id: 2,
      title: '2. Select number of users',
      body: "If you'd like to add more than 1 user, select the additional number of users in the dropdown. The price per additional user is listed above for each plan.",
      image: gs2,
    },
    {
      id: 3,
      title: '3. Add to account balance',
      body: 'Each plan comes with a pre-filled account balance from which message fees will be deducted in real-time. You can add additional balance to your account either automatically or manually anytime.',
      image: gs1,
    },
  ];

  const sections = datas.map((data) => (
    <div key={data.title} className="col-section">
      <img src={data.image} alt="" />
      <p className="fsz-20 bold-800 mt-15">{data.title}</p>
      <p className="fsz-16 mt-5">{data.body}</p>
      { data.id === 3 && <ViewMessageRates /> }
    </div>
  ));

  return (
    <div id="getting-started">
      <p className="bright-green fsz-14 bold-800 uppercase mb-5">Getting Started</p>
      <p className="header">How to get started and running in minutes</p>
      <div className="section-containers">
        {sections}
      </div>
    </div>
  );
};
